/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreatePortCall = /* GraphQL */ `
  subscription OnCreatePortCall {
    onCreatePortCall {
      id
      referenceId
      status
      lastZone
      remarks
      portCallCategoryId_
      category {
        id
        name
        description
        type
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      portCallTags
      documents
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      portCallVesselId_
      portCallVesselId
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      lastPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      nextPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfLoading {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfDischarge {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      cargos {
        items {
          id
          cargoPortCallId
          portCallArchived
          type {
            id
            name
            units
            code
            charge
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          initialAmount
          amount
          comments
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          cargoTypeId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      requests {
        items {
          id
          requestPortCallId
          requestPortCallId_
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          type
          source
          sourceData
          agent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          requesterUserName
          requesterEmail
          portCallData {
            vesselName
            vesselImo
            vesselMmsi
            vesselCallsign
            __typename
          }
          actionData {
            actionId
            actionTypeId
            movementType
            timeRequested
            timePlanned
            approved
            locationId
            __typename
          }
          remark
          createdAt
          updatedAt
          auditMeta {
            comment
            userId
            source
            __typename
          }
          _version
          _deleted
          _lastChangedAt
          requestAgentId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      agents {
        contactId
        actionId
        time
        __typename
      }
      sourceData
      createdAtDate
      archived
      arrivalTime
      departureTime
      origin
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      portLocationId
      portUnlocode
      finalArrivalPlannedTime
      finalArrivalRequestedTime
      finalArrivalActualTime
      finalDeparturePlannedTime
      finalDepartureRequestedTime
      finalDepartureActualTime
      sortTime
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallCategoryId
      __typename
    }
  }
`;
export const onUpdatePortCall = /* GraphQL */ `
  subscription OnUpdatePortCall {
    onUpdatePortCall {
      id
      referenceId
      status
      lastZone
      remarks
      portCallCategoryId_
      category {
        id
        name
        description
        type
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      portCallTags
      documents
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      portCallVesselId_
      portCallVesselId
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      lastPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      nextPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfLoading {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfDischarge {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      cargos {
        items {
          id
          cargoPortCallId
          portCallArchived
          type {
            id
            name
            units
            code
            charge
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          initialAmount
          amount
          comments
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          cargoTypeId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      requests {
        items {
          id
          requestPortCallId
          requestPortCallId_
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          type
          source
          sourceData
          agent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          requesterUserName
          requesterEmail
          portCallData {
            vesselName
            vesselImo
            vesselMmsi
            vesselCallsign
            __typename
          }
          actionData {
            actionId
            actionTypeId
            movementType
            timeRequested
            timePlanned
            approved
            locationId
            __typename
          }
          remark
          createdAt
          updatedAt
          auditMeta {
            comment
            userId
            source
            __typename
          }
          _version
          _deleted
          _lastChangedAt
          requestAgentId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      agents {
        contactId
        actionId
        time
        __typename
      }
      sourceData
      createdAtDate
      archived
      arrivalTime
      departureTime
      origin
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      portLocationId
      portUnlocode
      finalArrivalPlannedTime
      finalArrivalRequestedTime
      finalArrivalActualTime
      finalDeparturePlannedTime
      finalDepartureRequestedTime
      finalDepartureActualTime
      sortTime
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallCategoryId
      __typename
    }
  }
`;
export const onDeletePortCall = /* GraphQL */ `
  subscription OnDeletePortCall {
    onDeletePortCall {
      id
      referenceId
      status
      lastZone
      remarks
      portCallCategoryId_
      category {
        id
        name
        description
        type
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      portCallTags
      documents
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      portCallVesselId_
      portCallVesselId
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      lastPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      nextPort {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfLoading {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      portOfDischarge {
        name
        portCode
        countryCode
        searchString
        __typename
      }
      cargos {
        items {
          id
          cargoPortCallId
          portCallArchived
          type {
            id
            name
            units
            code
            charge
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          initialAmount
          amount
          comments
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          cargoTypeId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      requests {
        items {
          id
          requestPortCallId
          requestPortCallId_
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          type
          source
          sourceData
          agent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          requesterUserName
          requesterEmail
          portCallData {
            vesselName
            vesselImo
            vesselMmsi
            vesselCallsign
            __typename
          }
          actionData {
            actionId
            actionTypeId
            movementType
            timeRequested
            timePlanned
            approved
            locationId
            __typename
          }
          remark
          createdAt
          updatedAt
          auditMeta {
            comment
            userId
            source
            __typename
          }
          _version
          _deleted
          _lastChangedAt
          requestAgentId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      agents {
        contactId
        actionId
        time
        __typename
      }
      sourceData
      createdAtDate
      archived
      arrivalTime
      departureTime
      origin
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      portLocationId
      portUnlocode
      finalArrivalPlannedTime
      finalArrivalRequestedTime
      finalArrivalActualTime
      finalDeparturePlannedTime
      finalDepartureRequestedTime
      finalDepartureActualTime
      sortTime
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallCategoryId
      __typename
    }
  }
`;
export const onCreateAction = /* GraphQL */ `
  subscription OnCreateAction {
    onCreateAction {
      id
      actionPortCallId
      actionPortCallId_
      actionVoyageId
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      timeRequested
      timePlanned
      timeEstimated
      timeActual
      timeCompleted
      timeEstimatedUpdatedAt
      actionAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      remarks
      automationLockedOut
      vesselMastersName
      vesselCrew
      vesselPassengers
      vesselForwardDraught
      vesselAftDraught
      vesselSailingDraught
      vesselAirDraught
      type {
        id
        name
        lifecycle
        editable
        deleted
        used
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      movementType
      movementLocation {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      movementVesselReadyTime
      movementPilotBoardingTime
      movementPilots
      movementLinesmen
      movementMooringVessels
      movementPropulsionState
      movementPropulsionRemarks
      movementRudderState
      movementRudderRemarks
      movementFwdAzimuthState
      movementFwdAzimuthRemarks
      movementAftAzimuthState
      movementAftAzimuthRemarks
      movementFwdTunnelThrusterState
      movementFwdTunnelThrusterRemarks
      movementAftTunnelThrusterState
      movementAftTunnelThrusterRemarks
      eventType
      todos {
        title
        description
        status
        todoType
        __typename
      }
      documents
      chargeableItems {
        id
        tariffData {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        tariffUnit
        tariffSecondaryUnit
        tariffId
        tariffBookId
        overrideUnitCost
        notes
        quantity
        secondaryMult
        total
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      automationMeta {
        eventIds
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      actionActionAgentId
      actionTypeId
      actionMovementLocationId
      __typename
    }
  }
`;
export const onUpdateAction = /* GraphQL */ `
  subscription OnUpdateAction {
    onUpdateAction {
      id
      actionPortCallId
      actionPortCallId_
      actionVoyageId
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      timeRequested
      timePlanned
      timeEstimated
      timeActual
      timeCompleted
      timeEstimatedUpdatedAt
      actionAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      remarks
      automationLockedOut
      vesselMastersName
      vesselCrew
      vesselPassengers
      vesselForwardDraught
      vesselAftDraught
      vesselSailingDraught
      vesselAirDraught
      type {
        id
        name
        lifecycle
        editable
        deleted
        used
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      movementType
      movementLocation {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      movementVesselReadyTime
      movementPilotBoardingTime
      movementPilots
      movementLinesmen
      movementMooringVessels
      movementPropulsionState
      movementPropulsionRemarks
      movementRudderState
      movementRudderRemarks
      movementFwdAzimuthState
      movementFwdAzimuthRemarks
      movementAftAzimuthState
      movementAftAzimuthRemarks
      movementFwdTunnelThrusterState
      movementFwdTunnelThrusterRemarks
      movementAftTunnelThrusterState
      movementAftTunnelThrusterRemarks
      eventType
      todos {
        title
        description
        status
        todoType
        __typename
      }
      documents
      chargeableItems {
        id
        tariffData {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        tariffUnit
        tariffSecondaryUnit
        tariffId
        tariffBookId
        overrideUnitCost
        notes
        quantity
        secondaryMult
        total
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      automationMeta {
        eventIds
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      actionActionAgentId
      actionTypeId
      actionMovementLocationId
      __typename
    }
  }
`;
export const onDeleteAction = /* GraphQL */ `
  subscription OnDeleteAction {
    onDeleteAction {
      id
      actionPortCallId
      actionPortCallId_
      actionVoyageId
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      timeRequested
      timePlanned
      timeEstimated
      timeActual
      timeCompleted
      timeEstimatedUpdatedAt
      actionAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      remarks
      automationLockedOut
      vesselMastersName
      vesselCrew
      vesselPassengers
      vesselForwardDraught
      vesselAftDraught
      vesselSailingDraught
      vesselAirDraught
      type {
        id
        name
        lifecycle
        editable
        deleted
        used
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      movementType
      movementLocation {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      movementVesselReadyTime
      movementPilotBoardingTime
      movementPilots
      movementLinesmen
      movementMooringVessels
      movementPropulsionState
      movementPropulsionRemarks
      movementRudderState
      movementRudderRemarks
      movementFwdAzimuthState
      movementFwdAzimuthRemarks
      movementAftAzimuthState
      movementAftAzimuthRemarks
      movementFwdTunnelThrusterState
      movementFwdTunnelThrusterRemarks
      movementAftTunnelThrusterState
      movementAftTunnelThrusterRemarks
      eventType
      todos {
        title
        description
        status
        todoType
        __typename
      }
      documents
      chargeableItems {
        id
        tariffData {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        tariffUnit
        tariffSecondaryUnit
        tariffId
        tariffBookId
        overrideUnitCost
        notes
        quantity
        secondaryMult
        total
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      latestUserLogEntry {
        id
        comment
        userId
        timeChanged
        __typename
      }
      automationMeta {
        eventIds
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      actionActionAgentId
      actionTypeId
      actionMovementLocationId
      __typename
    }
  }
`;
export const onCreateCargo = /* GraphQL */ `
  subscription OnCreateCargo {
    onCreateCargo {
      id
      cargoPortCallId
      portCallArchived
      type {
        id
        name
        units
        code
        charge
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      initialAmount
      amount
      comments
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      cargoTypeId
      __typename
    }
  }
`;
export const onUpdateCargo = /* GraphQL */ `
  subscription OnUpdateCargo {
    onUpdateCargo {
      id
      cargoPortCallId
      portCallArchived
      type {
        id
        name
        units
        code
        charge
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      initialAmount
      amount
      comments
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      cargoTypeId
      __typename
    }
  }
`;
export const onDeleteCargo = /* GraphQL */ `
  subscription OnDeleteCargo {
    onDeleteCargo {
      id
      cargoPortCallId
      portCallArchived
      type {
        id
        name
        units
        code
        charge
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      initialAmount
      amount
      comments
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      cargoTypeId
      __typename
    }
  }
`;
export const onCreateRequest = /* GraphQL */ `
  subscription OnCreateRequest {
    onCreateRequest {
      id
      requestPortCallId
      requestPortCallId_
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      type
      source
      sourceData
      agent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      requesterUserName
      requesterEmail
      portCallData {
        vesselName
        vesselImo
        vesselMmsi
        vesselCallsign
        __typename
      }
      actionData {
        actionId
        actionTypeId
        movementType
        timeRequested
        timePlanned
        approved
        locationId
        __typename
      }
      remark
      createdAt
      updatedAt
      auditMeta {
        comment
        userId
        source
        __typename
      }
      _version
      _deleted
      _lastChangedAt
      requestAgentId
      __typename
    }
  }
`;
export const onUpdateRequest = /* GraphQL */ `
  subscription OnUpdateRequest {
    onUpdateRequest {
      id
      requestPortCallId
      requestPortCallId_
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      type
      source
      sourceData
      agent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      requesterUserName
      requesterEmail
      portCallData {
        vesselName
        vesselImo
        vesselMmsi
        vesselCallsign
        __typename
      }
      actionData {
        actionId
        actionTypeId
        movementType
        timeRequested
        timePlanned
        approved
        locationId
        __typename
      }
      remark
      createdAt
      updatedAt
      auditMeta {
        comment
        userId
        source
        __typename
      }
      _version
      _deleted
      _lastChangedAt
      requestAgentId
      __typename
    }
  }
`;
export const onDeleteRequest = /* GraphQL */ `
  subscription OnDeleteRequest {
    onDeleteRequest {
      id
      requestPortCallId
      requestPortCallId_
      portCall {
        id
        referenceId
        status
        lastZone
        remarks
        portCallCategoryId_
        category {
          id
          name
          description
          type
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        portCallTags
        documents
        actions {
          items {
            id
            actionPortCallId
            actionPortCallId_
            actionVoyageId
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            timeRequested
            timePlanned
            timeEstimated
            timeActual
            timeCompleted
            timeEstimatedUpdatedAt
            actionAgent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            remarks
            automationLockedOut
            vesselMastersName
            vesselCrew
            vesselPassengers
            vesselForwardDraught
            vesselAftDraught
            vesselSailingDraught
            vesselAirDraught
            type {
              id
              name
              lifecycle
              editable
              deleted
              used
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            movementType
            movementLocation {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            movementVesselReadyTime
            movementPilotBoardingTime
            movementPilots
            movementLinesmen
            movementMooringVessels
            movementPropulsionState
            movementPropulsionRemarks
            movementRudderState
            movementRudderRemarks
            movementFwdAzimuthState
            movementFwdAzimuthRemarks
            movementAftAzimuthState
            movementAftAzimuthRemarks
            movementFwdTunnelThrusterState
            movementFwdTunnelThrusterRemarks
            movementAftTunnelThrusterState
            movementAftTunnelThrusterRemarks
            eventType
            todos {
              title
              description
              status
              todoType
              __typename
            }
            documents
            chargeableItems {
              id
              tariffData {
                code
                description
                unitCost
                currency
                notes
                minimumCost
                actionTypes
                __typename
              }
              tariffUnit
              tariffSecondaryUnit
              tariffId
              tariffBookId
              overrideUnitCost
              notes
              quantity
              secondaryMult
              total
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            automationMeta {
              eventIds
              __typename
            }
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            actionActionAgentId
            actionTypeId
            actionMovementLocationId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        portCallVesselId_
        portCallVesselId
        vessel {
          id
          imo
          mmsi
          callSign
          vesselData {
            name
            imo
            mmsi
            image
            callSign
            type
            portOfRegistry {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            flag
            lengthOverall
            beam
            draught
            grossTonnage
            deadWeightTonnage
            netTonnage
            yearBuilt
            propellerCount
            propulsionType
            propellerDirection
            propulsionPower
            propulsionPowerUnit
            rudderCount
            rudderType
            fwdAzimuthCount
            fwdAzimuthPower
            fwdAzimuthPowerUnit
            aftAzimuthCount
            aftAzimuthPower
            aftAzimuthPowerUnit
            fwdTunnelThrusterCount
            fwdTunnelThrusterPower
            fwdTunnelThrusterPowerUnit
            aftTunnelThrusterCount
            aftTunnelThrusterPower
            aftTunnelThrusterPowerUnit
            certificates {
              id
              type
              typeName
              typeCategory
              typeCategoryName
              notes
              validFromDate
              validToDate
              referenceNumber
              nameOfHolder
              __typename
            }
            __typename
          }
          vesselAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          vesselVesselAgentId
          __typename
        }
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        lastPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        nextPort {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfLoading {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        portOfDischarge {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        cargos {
          items {
            id
            cargoPortCallId
            portCallArchived
            type {
              id
              name
              units
              code
              charge
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            initialAmount
            amount
            comments
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            cargoTypeId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        requests {
          items {
            id
            requestPortCallId
            requestPortCallId_
            portCall {
              id
              referenceId
              status
              lastZone
              remarks
              portCallCategoryId_
              category {
                id
                name
                description
                type
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              portCallTags
              documents
              actions {
                nextToken
                startedAt
                __typename
              }
              portCallVesselId_
              portCallVesselId
              vessel {
                id
                imo
                mmsi
                callSign
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                vesselVesselAgentId
                __typename
              }
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              lastPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              nextPort {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfLoading {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              portOfDischarge {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              cargos {
                nextToken
                startedAt
                __typename
              }
              requests {
                nextToken
                startedAt
                __typename
              }
              agents {
                contactId
                actionId
                time
                __typename
              }
              sourceData
              createdAtDate
              archived
              arrivalTime
              departureTime
              origin
              latestUserLogEntry {
                id
                comment
                userId
                timeChanged
                __typename
              }
              auditMeta {
                comment
                userId
                source
                __typename
              }
              portLocationId
              portUnlocode
              finalArrivalPlannedTime
              finalArrivalRequestedTime
              finalArrivalActualTime
              finalDeparturePlannedTime
              finalDepartureRequestedTime
              finalDepartureActualTime
              sortTime
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              portCallCategoryId
              __typename
            }
            portCallArchived
            state
            type
            source
            sourceData
            agent {
              id
              type {
                id
                name
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                __typename
              }
              name
              displayName
              reference
              address1
              address2
              town
              county
              postcode
              number
              fax
              email
              contacta_name
              contacta_detail
              contactb_name
              contactb_detail
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              contactTypeId
              __typename
            }
            requesterUserName
            requesterEmail
            portCallData {
              vesselName
              vesselImo
              vesselMmsi
              vesselCallsign
              __typename
            }
            actionData {
              actionId
              actionTypeId
              movementType
              timeRequested
              timePlanned
              approved
              locationId
              __typename
            }
            remark
            createdAt
            updatedAt
            auditMeta {
              comment
              userId
              source
              __typename
            }
            _version
            _deleted
            _lastChangedAt
            requestAgentId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        agents {
          contactId
          actionId
          time
          __typename
        }
        sourceData
        createdAtDate
        archived
        arrivalTime
        departureTime
        origin
        latestUserLogEntry {
          id
          comment
          userId
          timeChanged
          __typename
        }
        auditMeta {
          comment
          userId
          source
          __typename
        }
        portLocationId
        portUnlocode
        finalArrivalPlannedTime
        finalArrivalRequestedTime
        finalArrivalActualTime
        finalDeparturePlannedTime
        finalDepartureRequestedTime
        finalDepartureActualTime
        sortTime
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        portCallCategoryId
        __typename
      }
      portCallArchived
      state
      type
      source
      sourceData
      agent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      requesterUserName
      requesterEmail
      portCallData {
        vesselName
        vesselImo
        vesselMmsi
        vesselCallsign
        __typename
      }
      actionData {
        actionId
        actionTypeId
        movementType
        timeRequested
        timePlanned
        approved
        locationId
        __typename
      }
      remark
      createdAt
      updatedAt
      auditMeta {
        comment
        userId
        source
        __typename
      }
      _version
      _deleted
      _lastChangedAt
      requestAgentId
      __typename
    }
  }
`;
export const onCreateVoyage = /* GraphQL */ `
  subscription OnCreateVoyage {
    onCreateVoyage {
      id
      name
      status
      lastImportSha256
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      voyageFirstDeparture
      voyageLastArrival
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      voyageVesselId
      __typename
    }
  }
`;
export const onUpdateVoyage = /* GraphQL */ `
  subscription OnUpdateVoyage {
    onUpdateVoyage {
      id
      name
      status
      lastImportSha256
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      voyageFirstDeparture
      voyageLastArrival
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      voyageVesselId
      __typename
    }
  }
`;
export const onDeleteVoyage = /* GraphQL */ `
  subscription OnDeleteVoyage {
    onDeleteVoyage {
      id
      name
      status
      lastImportSha256
      vessel {
        id
        imo
        mmsi
        callSign
        vesselData {
          name
          imo
          mmsi
          image
          callSign
          type
          portOfRegistry {
            name
            portCode
            countryCode
            searchString
            __typename
          }
          flag
          lengthOverall
          beam
          draught
          grossTonnage
          deadWeightTonnage
          netTonnage
          yearBuilt
          propellerCount
          propulsionType
          propellerDirection
          propulsionPower
          propulsionPowerUnit
          rudderCount
          rudderType
          fwdAzimuthCount
          fwdAzimuthPower
          fwdAzimuthPowerUnit
          aftAzimuthCount
          aftAzimuthPower
          aftAzimuthPowerUnit
          fwdTunnelThrusterCount
          fwdTunnelThrusterPower
          fwdTunnelThrusterPowerUnit
          aftTunnelThrusterCount
          aftTunnelThrusterPower
          aftTunnelThrusterPowerUnit
          certificates {
            id
            type
            typeName
            typeCategory
            typeCategoryName
            notes
            validFromDate
            validToDate
            referenceNumber
            nameOfHolder
            __typename
          }
          __typename
        }
        vesselAgent {
          id
          type {
            id
            name
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          name
          displayName
          reference
          address1
          address2
          town
          county
          postcode
          number
          fax
          email
          contacta_name
          contacta_detail
          contactb_name
          contactb_detail
          deleted
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          contactTypeId
          __typename
        }
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        vesselVesselAgentId
        __typename
      }
      actions {
        items {
          id
          actionPortCallId
          actionPortCallId_
          actionVoyageId
          portCall {
            id
            referenceId
            status
            lastZone
            remarks
            portCallCategoryId_
            category {
              id
              name
              description
              type
              deleted
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            portCallTags
            documents
            actions {
              items {
                id
                actionPortCallId
                actionPortCallId_
                actionVoyageId
                portCallArchived
                state
                timeRequested
                timePlanned
                timeEstimated
                timeActual
                timeCompleted
                timeEstimatedUpdatedAt
                remarks
                automationLockedOut
                vesselMastersName
                vesselCrew
                vesselPassengers
                vesselForwardDraught
                vesselAftDraught
                vesselSailingDraught
                vesselAirDraught
                movementType
                movementVesselReadyTime
                movementPilotBoardingTime
                movementPilots
                movementLinesmen
                movementMooringVessels
                movementPropulsionState
                movementPropulsionRemarks
                movementRudderState
                movementRudderRemarks
                movementFwdAzimuthState
                movementFwdAzimuthRemarks
                movementAftAzimuthState
                movementAftAzimuthRemarks
                movementFwdTunnelThrusterState
                movementFwdTunnelThrusterRemarks
                movementAftTunnelThrusterState
                movementAftTunnelThrusterRemarks
                eventType
                documents
                updatedAt
                createdAt
                _version
                _deleted
                _lastChangedAt
                actionActionAgentId
                actionTypeId
                actionMovementLocationId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            portCallVesselId_
            portCallVesselId
            vessel {
              id
              imo
              mmsi
              callSign
              vesselData {
                name
                imo
                mmsi
                image
                callSign
                type
                flag
                lengthOverall
                beam
                draught
                grossTonnage
                deadWeightTonnage
                netTonnage
                yearBuilt
                propellerCount
                propulsionType
                propellerDirection
                propulsionPower
                propulsionPowerUnit
                rudderCount
                rudderType
                fwdAzimuthCount
                fwdAzimuthPower
                fwdAzimuthPowerUnit
                aftAzimuthCount
                aftAzimuthPower
                aftAzimuthPowerUnit
                fwdTunnelThrusterCount
                fwdTunnelThrusterPower
                fwdTunnelThrusterPowerUnit
                aftTunnelThrusterCount
                aftTunnelThrusterPower
                aftTunnelThrusterPowerUnit
                __typename
              }
              vesselAgent {
                id
                name
                displayName
                reference
                address1
                address2
                town
                county
                postcode
                number
                fax
                email
                contacta_name
                contacta_detail
                contactb_name
                contactb_detail
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                contactTypeId
                __typename
              }
              updatedAt
              createdAt
              _version
              _deleted
              _lastChangedAt
              vesselVesselAgentId
              __typename
            }
            vesselData {
              name
              imo
              mmsi
              image
              callSign
              type
              portOfRegistry {
                name
                portCode
                countryCode
                searchString
                __typename
              }
              flag
              lengthOverall
              beam
              draught
              grossTonnage
              deadWeightTonnage
              netTonnage
              yearBuilt
              propellerCount
              propulsionType
              propellerDirection
              propulsionPower
              propulsionPowerUnit
              rudderCount
              rudderType
              fwdAzimuthCount
              fwdAzimuthPower
              fwdAzimuthPowerUnit
              aftAzimuthCount
              aftAzimuthPower
              aftAzimuthPowerUnit
              fwdTunnelThrusterCount
              fwdTunnelThrusterPower
              fwdTunnelThrusterPowerUnit
              aftTunnelThrusterCount
              aftTunnelThrusterPower
              aftTunnelThrusterPowerUnit
              certificates {
                id
                type
                typeName
                typeCategory
                typeCategoryName
                notes
                validFromDate
                validToDate
                referenceNumber
                nameOfHolder
                __typename
              }
              __typename
            }
            lastPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            nextPort {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfLoading {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            portOfDischarge {
              name
              portCode
              countryCode
              searchString
              __typename
            }
            cargos {
              items {
                id
                cargoPortCallId
                portCallArchived
                initialAmount
                amount
                comments
                deleted
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                cargoTypeId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            requests {
              items {
                id
                requestPortCallId
                requestPortCallId_
                portCallArchived
                state
                type
                source
                sourceData
                requesterUserName
                requesterEmail
                remark
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                requestAgentId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            agents {
              contactId
              actionId
              time
              __typename
            }
            sourceData
            createdAtDate
            archived
            arrivalTime
            departureTime
            origin
            latestUserLogEntry {
              id
              comment
              userId
              timeChanged
              __typename
            }
            auditMeta {
              comment
              userId
              source
              __typename
            }
            portLocationId
            portUnlocode
            finalArrivalPlannedTime
            finalArrivalRequestedTime
            finalArrivalActualTime
            finalDeparturePlannedTime
            finalDepartureRequestedTime
            finalDepartureActualTime
            sortTime
            updatedAt
            createdAt
            _version
            _deleted
            _lastChangedAt
            portCallCategoryId
            __typename
          }
          portCallArchived
          state
          timeRequested
          timePlanned
          timeEstimated
          timeActual
          timeCompleted
          timeEstimatedUpdatedAt
          actionAgent {
            id
            type {
              id
              name
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            name
            displayName
            reference
            address1
            address2
            town
            county
            postcode
            number
            fax
            email
            contacta_name
            contacta_detail
            contactb_name
            contactb_detail
            deleted
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            contactTypeId
            __typename
          }
          remarks
          automationLockedOut
          vesselMastersName
          vesselCrew
          vesselPassengers
          vesselForwardDraught
          vesselAftDraught
          vesselSailingDraught
          vesselAirDraught
          type {
            id
            name
            lifecycle
            editable
            deleted
            used
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          movementType
          movementLocation {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          movementVesselReadyTime
          movementPilotBoardingTime
          movementPilots
          movementLinesmen
          movementMooringVessels
          movementPropulsionState
          movementPropulsionRemarks
          movementRudderState
          movementRudderRemarks
          movementFwdAzimuthState
          movementFwdAzimuthRemarks
          movementAftAzimuthState
          movementAftAzimuthRemarks
          movementFwdTunnelThrusterState
          movementFwdTunnelThrusterRemarks
          movementAftTunnelThrusterState
          movementAftTunnelThrusterRemarks
          eventType
          todos {
            title
            description
            status
            todoType
            __typename
          }
          documents
          chargeableItems {
            id
            tariffData {
              code
              description
              unitCost
              currency
              notes
              minimumCost
              actionTypes
              __typename
            }
            tariffUnit
            tariffSecondaryUnit
            tariffId
            tariffBookId
            overrideUnitCost
            notes
            quantity
            secondaryMult
            total
            __typename
          }
          auditMeta {
            comment
            userId
            source
            __typename
          }
          latestUserLogEntry {
            id
            comment
            userId
            timeChanged
            __typename
          }
          automationMeta {
            eventIds
            __typename
          }
          updatedAt
          createdAt
          _version
          _deleted
          _lastChangedAt
          actionActionAgentId
          actionTypeId
          actionMovementLocationId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      voyageFirstDeparture
      voyageLastArrival
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      voyageVesselId
      __typename
    }
  }
`;
export const onFileExportResult = /* GraphQL */ `
  subscription OnFileExportResult {
    onFileExportResult {
      s3Key
      id
      status
      from
      sentAt
      __typename
    }
  }
`;
export const onCreateSetting = /* GraphQL */ `
  subscription OnCreateSetting($filter: ModelSubscriptionSettingFilterInput) {
    onCreateSetting(filter: $filter) {
      id
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateSetting = /* GraphQL */ `
  subscription OnUpdateSetting($filter: ModelSubscriptionSettingFilterInput) {
    onUpdateSetting(filter: $filter) {
      id
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteSetting = /* GraphQL */ `
  subscription OnDeleteSetting($filter: ModelSubscriptionSettingFilterInput) {
    onDeleteSetting(filter: $filter) {
      id
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateUserSetting = /* GraphQL */ `
  subscription OnCreateUserSetting(
    $filter: ModelSubscriptionUserSettingFilterInput
  ) {
    onCreateUserSetting(filter: $filter) {
      id
      language
      mapLayer
      exportConfig {
        lengthUnit
        columns
        __typename
      }
      movementsFilterId
      berthsFilterId
      fullScreen
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateUserSetting = /* GraphQL */ `
  subscription OnUpdateUserSetting(
    $filter: ModelSubscriptionUserSettingFilterInput
  ) {
    onUpdateUserSetting(filter: $filter) {
      id
      language
      mapLayer
      exportConfig {
        lengthUnit
        columns
        __typename
      }
      movementsFilterId
      berthsFilterId
      fullScreen
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteUserSetting = /* GraphQL */ `
  subscription OnDeleteUserSetting(
    $filter: ModelSubscriptionUserSettingFilterInput
  ) {
    onDeleteUserSetting(filter: $filter) {
      id
      language
      mapLayer
      exportConfig {
        lengthUnit
        columns
        __typename
      }
      movementsFilterId
      berthsFilterId
      fullScreen
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateCategory = /* GraphQL */ `
  subscription OnCreateCategory($filter: ModelSubscriptionCategoryFilterInput) {
    onCreateCategory(filter: $filter) {
      id
      name
      description
      type
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCategory = /* GraphQL */ `
  subscription OnUpdateCategory($filter: ModelSubscriptionCategoryFilterInput) {
    onUpdateCategory(filter: $filter) {
      id
      name
      description
      type
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCategory = /* GraphQL */ `
  subscription OnDeleteCategory($filter: ModelSubscriptionCategoryFilterInput) {
    onDeleteCategory(filter: $filter) {
      id
      name
      description
      type
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateAuditLog = /* GraphQL */ `
  subscription OnCreateAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onCreateAuditLog(filter: $filter) {
      id
      table
      type
      source
      userId
      comment
      timeChanged
      objectId
      portCallId
      old
      new
      data
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateAuditLog = /* GraphQL */ `
  subscription OnUpdateAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onUpdateAuditLog(filter: $filter) {
      id
      table
      type
      source
      userId
      comment
      timeChanged
      objectId
      portCallId
      old
      new
      data
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteAuditLog = /* GraphQL */ `
  subscription OnDeleteAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onDeleteAuditLog(filter: $filter) {
      id
      table
      type
      source
      userId
      comment
      timeChanged
      objectId
      portCallId
      old
      new
      data
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreatePortCallData = /* GraphQL */ `
  subscription OnCreatePortCallData(
    $filter: ModelSubscriptionPortCallDataFilterInput
  ) {
    onCreatePortCallData(filter: $filter) {
      id
      type
      portCallId
      actionId
      data
      s3file {
        id
        name
        s3Path
        mimeType
        sizeBytes
        portCallId
        actionId
        type
        auditMeta {
          comment
          userId
          source
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallDataS3fileId
      __typename
    }
  }
`;
export const onUpdatePortCallData = /* GraphQL */ `
  subscription OnUpdatePortCallData(
    $filter: ModelSubscriptionPortCallDataFilterInput
  ) {
    onUpdatePortCallData(filter: $filter) {
      id
      type
      portCallId
      actionId
      data
      s3file {
        id
        name
        s3Path
        mimeType
        sizeBytes
        portCallId
        actionId
        type
        auditMeta {
          comment
          userId
          source
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallDataS3fileId
      __typename
    }
  }
`;
export const onDeletePortCallData = /* GraphQL */ `
  subscription OnDeletePortCallData(
    $filter: ModelSubscriptionPortCallDataFilterInput
  ) {
    onDeletePortCallData(filter: $filter) {
      id
      type
      portCallId
      actionId
      data
      s3file {
        id
        name
        s3Path
        mimeType
        sizeBytes
        portCallId
        actionId
        type
        auditMeta {
          comment
          userId
          source
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      auditMeta {
        comment
        userId
        source
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      portCallDataS3fileId
      __typename
    }
  }
`;
export const onCreateContactType = /* GraphQL */ `
  subscription OnCreateContactType(
    $filter: ModelSubscriptionContactTypeFilterInput
  ) {
    onCreateContactType(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateContactType = /* GraphQL */ `
  subscription OnUpdateContactType(
    $filter: ModelSubscriptionContactTypeFilterInput
  ) {
    onUpdateContactType(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteContactType = /* GraphQL */ `
  subscription OnDeleteContactType(
    $filter: ModelSubscriptionContactTypeFilterInput
  ) {
    onDeleteContactType(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateContact = /* GraphQL */ `
  subscription OnCreateContact($filter: ModelSubscriptionContactFilterInput) {
    onCreateContact(filter: $filter) {
      id
      type {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      displayName
      reference
      address1
      address2
      town
      county
      postcode
      number
      fax
      email
      contacta_name
      contacta_detail
      contactb_name
      contactb_detail
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      contactTypeId
      __typename
    }
  }
`;
export const onUpdateContact = /* GraphQL */ `
  subscription OnUpdateContact($filter: ModelSubscriptionContactFilterInput) {
    onUpdateContact(filter: $filter) {
      id
      type {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      displayName
      reference
      address1
      address2
      town
      county
      postcode
      number
      fax
      email
      contacta_name
      contacta_detail
      contactb_name
      contactb_detail
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      contactTypeId
      __typename
    }
  }
`;
export const onDeleteContact = /* GraphQL */ `
  subscription OnDeleteContact($filter: ModelSubscriptionContactFilterInput) {
    onDeleteContact(filter: $filter) {
      id
      type {
        id
        name
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      name
      displayName
      reference
      address1
      address2
      town
      county
      postcode
      number
      fax
      email
      contacta_name
      contacta_detail
      contactb_name
      contactb_detail
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      contactTypeId
      __typename
    }
  }
`;
export const onCreateVessel = /* GraphQL */ `
  subscription OnCreateVessel($filter: ModelSubscriptionVesselFilterInput) {
    onCreateVessel(filter: $filter) {
      id
      imo
      mmsi
      callSign
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      vesselAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      vesselVesselAgentId
      __typename
    }
  }
`;
export const onUpdateVessel = /* GraphQL */ `
  subscription OnUpdateVessel($filter: ModelSubscriptionVesselFilterInput) {
    onUpdateVessel(filter: $filter) {
      id
      imo
      mmsi
      callSign
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      vesselAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      vesselVesselAgentId
      __typename
    }
  }
`;
export const onDeleteVessel = /* GraphQL */ `
  subscription OnDeleteVessel($filter: ModelSubscriptionVesselFilterInput) {
    onDeleteVessel(filter: $filter) {
      id
      imo
      mmsi
      callSign
      vesselData {
        name
        imo
        mmsi
        image
        callSign
        type
        portOfRegistry {
          name
          portCode
          countryCode
          searchString
          __typename
        }
        flag
        lengthOverall
        beam
        draught
        grossTonnage
        deadWeightTonnage
        netTonnage
        yearBuilt
        propellerCount
        propulsionType
        propellerDirection
        propulsionPower
        propulsionPowerUnit
        rudderCount
        rudderType
        fwdAzimuthCount
        fwdAzimuthPower
        fwdAzimuthPowerUnit
        aftAzimuthCount
        aftAzimuthPower
        aftAzimuthPowerUnit
        fwdTunnelThrusterCount
        fwdTunnelThrusterPower
        fwdTunnelThrusterPowerUnit
        aftTunnelThrusterCount
        aftTunnelThrusterPower
        aftTunnelThrusterPowerUnit
        certificates {
          id
          type
          typeName
          typeCategory
          typeCategoryName
          notes
          validFromDate
          validToDate
          referenceNumber
          nameOfHolder
          __typename
        }
        __typename
      }
      vesselAgent {
        id
        type {
          id
          name
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        name
        displayName
        reference
        address1
        address2
        town
        county
        postcode
        number
        fax
        email
        contacta_name
        contacta_detail
        contactb_name
        contactb_detail
        deleted
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        contactTypeId
        __typename
      }
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      vesselVesselAgentId
      __typename
    }
  }
`;
export const onCreateCargoType = /* GraphQL */ `
  subscription OnCreateCargoType(
    $filter: ModelSubscriptionCargoTypeFilterInput
  ) {
    onCreateCargoType(filter: $filter) {
      id
      name
      units
      code
      charge
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCargoType = /* GraphQL */ `
  subscription OnUpdateCargoType(
    $filter: ModelSubscriptionCargoTypeFilterInput
  ) {
    onUpdateCargoType(filter: $filter) {
      id
      name
      units
      code
      charge
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCargoType = /* GraphQL */ `
  subscription OnDeleteCargoType(
    $filter: ModelSubscriptionCargoTypeFilterInput
  ) {
    onDeleteCargoType(filter: $filter) {
      id
      name
      units
      code
      charge
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTariffUnit = /* GraphQL */ `
  subscription OnCreateTariffUnit(
    $filter: ModelSubscriptionTariffUnitFilterInput
  ) {
    onCreateTariffUnit(filter: $filter) {
      id
      name
      secondaryUnitName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTariffUnit = /* GraphQL */ `
  subscription OnUpdateTariffUnit(
    $filter: ModelSubscriptionTariffUnitFilterInput
  ) {
    onUpdateTariffUnit(filter: $filter) {
      id
      name
      secondaryUnitName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTariffUnit = /* GraphQL */ `
  subscription OnDeleteTariffUnit(
    $filter: ModelSubscriptionTariffUnitFilterInput
  ) {
    onDeleteTariffUnit(filter: $filter) {
      id
      name
      secondaryUnitName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTariff = /* GraphQL */ `
  subscription OnCreateTariff($filter: ModelSubscriptionTariffFilterInput) {
    onCreateTariff(filter: $filter) {
      id
      unit {
        id
        name
        secondaryUnitName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      data {
        code
        description
        unitCost
        currency
        notes
        minimumCost
        actionTypes
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tariffUnitId
      __typename
    }
  }
`;
export const onUpdateTariff = /* GraphQL */ `
  subscription OnUpdateTariff($filter: ModelSubscriptionTariffFilterInput) {
    onUpdateTariff(filter: $filter) {
      id
      unit {
        id
        name
        secondaryUnitName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      data {
        code
        description
        unitCost
        currency
        notes
        minimumCost
        actionTypes
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tariffUnitId
      __typename
    }
  }
`;
export const onDeleteTariff = /* GraphQL */ `
  subscription OnDeleteTariff($filter: ModelSubscriptionTariffFilterInput) {
    onDeleteTariff(filter: $filter) {
      id
      unit {
        id
        name
        secondaryUnitName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      data {
        code
        description
        unitCost
        currency
        notes
        minimumCost
        actionTypes
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tariffUnitId
      __typename
    }
  }
`;
export const onCreateTariffBook = /* GraphQL */ `
  subscription OnCreateTariffBook(
    $filter: ModelSubscriptionTariffBookFilterInput
  ) {
    onCreateTariffBook(filter: $filter) {
      id
      name
      description
      dateValidFrom
      dateValidTo
      tariffs {
        id
        unitId
        cost {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        __typename
      }
      defaultCharges {
        id
        actionTypeId
        movementType
        defaultItems {
          id
          tariffId
          overrideUnitCost
          quantity
          secondaryMult
          notes
          __typename
        }
        __typename
      }
      parentBook
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTariffBook = /* GraphQL */ `
  subscription OnUpdateTariffBook(
    $filter: ModelSubscriptionTariffBookFilterInput
  ) {
    onUpdateTariffBook(filter: $filter) {
      id
      name
      description
      dateValidFrom
      dateValidTo
      tariffs {
        id
        unitId
        cost {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        __typename
      }
      defaultCharges {
        id
        actionTypeId
        movementType
        defaultItems {
          id
          tariffId
          overrideUnitCost
          quantity
          secondaryMult
          notes
          __typename
        }
        __typename
      }
      parentBook
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTariffBook = /* GraphQL */ `
  subscription OnDeleteTariffBook(
    $filter: ModelSubscriptionTariffBookFilterInput
  ) {
    onDeleteTariffBook(filter: $filter) {
      id
      name
      description
      dateValidFrom
      dateValidTo
      tariffs {
        id
        unitId
        cost {
          code
          description
          unitCost
          currency
          notes
          minimumCost
          actionTypes
          __typename
        }
        __typename
      }
      defaultCharges {
        id
        actionTypeId
        movementType
        defaultItems {
          id
          tariffId
          overrideUnitCost
          quantity
          secondaryMult
          notes
          __typename
        }
        __typename
      }
      parentBook
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateActionType = /* GraphQL */ `
  subscription OnCreateActionType(
    $filter: ModelSubscriptionActionTypeFilterInput
  ) {
    onCreateActionType(filter: $filter) {
      id
      name
      lifecycle
      editable
      deleted
      used
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateActionType = /* GraphQL */ `
  subscription OnUpdateActionType(
    $filter: ModelSubscriptionActionTypeFilterInput
  ) {
    onUpdateActionType(filter: $filter) {
      id
      name
      lifecycle
      editable
      deleted
      used
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteActionType = /* GraphQL */ `
  subscription OnDeleteActionType(
    $filter: ModelSubscriptionActionTypeFilterInput
  ) {
    onDeleteActionType(filter: $filter) {
      id
      name
      lifecycle
      editable
      deleted
      used
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateLocation = /* GraphQL */ `
  subscription OnCreateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onCreateLocation(filter: $filter) {
      id
      type
      name
      portUnlocode
      allocatable
      dockable
      locationParentId
      parent {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      children {
        items {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      parentName
      dimensions {
        length
        breadth
        depth
        __typename
      }
      shape
      coords
      path
      number
      marlinZoneId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationChildrenId
      __typename
    }
  }
`;
export const onUpdateLocation = /* GraphQL */ `
  subscription OnUpdateLocation($filter: ModelSubscriptionLocationFilterInput) {
    onUpdateLocation(filter: $filter) {
      id
      type
      name
      portUnlocode
      allocatable
      dockable
      locationParentId
      parent {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      children {
        items {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      parentName
      dimensions {
        length
        breadth
        depth
        __typename
      }
      shape
      coords
      path
      number
      marlinZoneId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationChildrenId
      __typename
    }
  }
`;
export const onDeleteLocation = /* GraphQL */ `
  subscription OnDeleteLocation($filter: ModelSubscriptionLocationFilterInput) {
    onDeleteLocation(filter: $filter) {
      id
      type
      name
      portUnlocode
      allocatable
      dockable
      locationParentId
      parent {
        id
        type
        name
        portUnlocode
        allocatable
        dockable
        locationParentId
        parent {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        children {
          items {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          nextToken
          startedAt
          __typename
        }
        parentName
        dimensions {
          length
          breadth
          depth
          __typename
        }
        shape
        coords
        path
        number
        marlinZoneId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        locationChildrenId
        __typename
      }
      children {
        items {
          id
          type
          name
          portUnlocode
          allocatable
          dockable
          locationParentId
          parent {
            id
            type
            name
            portUnlocode
            allocatable
            dockable
            locationParentId
            parent {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            children {
              items {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              nextToken
              startedAt
              __typename
            }
            parentName
            dimensions {
              length
              breadth
              depth
              __typename
            }
            shape
            coords
            path
            number
            marlinZoneId
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            locationChildrenId
            __typename
          }
          children {
            items {
              id
              type
              name
              portUnlocode
              allocatable
              dockable
              locationParentId
              parent {
                id
                type
                name
                portUnlocode
                allocatable
                dockable
                locationParentId
                parentName
                shape
                coords
                path
                number
                marlinZoneId
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                locationChildrenId
                __typename
              }
              children {
                nextToken
                startedAt
                __typename
              }
              parentName
              dimensions {
                length
                breadth
                depth
                __typename
              }
              shape
              coords
              path
              number
              marlinZoneId
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              locationChildrenId
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          parentName
          dimensions {
            length
            breadth
            depth
            __typename
          }
          shape
          coords
          path
          number
          marlinZoneId
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          locationChildrenId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      parentName
      dimensions {
        length
        breadth
        depth
        __typename
      }
      shape
      coords
      path
      number
      marlinZoneId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      locationChildrenId
      __typename
    }
  }
`;
export const onCreatePilotTag = /* GraphQL */ `
  subscription OnCreatePilotTag($filter: ModelSubscriptionPilotTagFilterInput) {
    onCreatePilotTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdatePilotTag = /* GraphQL */ `
  subscription OnUpdatePilotTag($filter: ModelSubscriptionPilotTagFilterInput) {
    onUpdatePilotTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeletePilotTag = /* GraphQL */ `
  subscription OnDeletePilotTag($filter: ModelSubscriptionPilotTagFilterInput) {
    onDeletePilotTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateMooringVesselTag = /* GraphQL */ `
  subscription OnCreateMooringVesselTag(
    $filter: ModelSubscriptionMooringVesselTagFilterInput
  ) {
    onCreateMooringVesselTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateMooringVesselTag = /* GraphQL */ `
  subscription OnUpdateMooringVesselTag(
    $filter: ModelSubscriptionMooringVesselTagFilterInput
  ) {
    onUpdateMooringVesselTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteMooringVesselTag = /* GraphQL */ `
  subscription OnDeleteMooringVesselTag(
    $filter: ModelSubscriptionMooringVesselTagFilterInput
  ) {
    onDeleteMooringVesselTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateLinesmanTag = /* GraphQL */ `
  subscription OnCreateLinesmanTag(
    $filter: ModelSubscriptionLinesmanTagFilterInput
  ) {
    onCreateLinesmanTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateLinesmanTag = /* GraphQL */ `
  subscription OnUpdateLinesmanTag(
    $filter: ModelSubscriptionLinesmanTagFilterInput
  ) {
    onUpdateLinesmanTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteLinesmanTag = /* GraphQL */ `
  subscription OnDeleteLinesmanTag(
    $filter: ModelSubscriptionLinesmanTagFilterInput
  ) {
    onDeleteLinesmanTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreatePortCallTag = /* GraphQL */ `
  subscription OnCreatePortCallTag(
    $filter: ModelSubscriptionPortCallTagFilterInput
  ) {
    onCreatePortCallTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdatePortCallTag = /* GraphQL */ `
  subscription OnUpdatePortCallTag(
    $filter: ModelSubscriptionPortCallTagFilterInput
  ) {
    onUpdatePortCallTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeletePortCallTag = /* GraphQL */ `
  subscription OnDeletePortCallTag(
    $filter: ModelSubscriptionPortCallTagFilterInput
  ) {
    onDeletePortCallTag(filter: $filter) {
      id
      name
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateFilter = /* GraphQL */ `
  subscription OnCreateFilter($filter: ModelSubscriptionFilterFilterInput) {
    onCreateFilter(filter: $filter) {
      id
      friendlyId
      type
      name
      status
      location
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateFilter = /* GraphQL */ `
  subscription OnUpdateFilter($filter: ModelSubscriptionFilterFilterInput) {
    onUpdateFilter(filter: $filter) {
      id
      friendlyId
      type
      name
      status
      location
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteFilter = /* GraphQL */ `
  subscription OnDeleteFilter($filter: ModelSubscriptionFilterFilterInput) {
    onDeleteFilter(filter: $filter) {
      id
      friendlyId
      type
      name
      status
      location
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTodoTypeTemplate = /* GraphQL */ `
  subscription OnCreateTodoTypeTemplate(
    $filter: ModelSubscriptionTodoTypeTemplateFilterInput
  ) {
    onCreateTodoTypeTemplate(filter: $filter) {
      id
      todoTypeName
      todoTypeTitle
      todoTypeDescription
      todoTypeColor
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTodoTypeTemplate = /* GraphQL */ `
  subscription OnUpdateTodoTypeTemplate(
    $filter: ModelSubscriptionTodoTypeTemplateFilterInput
  ) {
    onUpdateTodoTypeTemplate(filter: $filter) {
      id
      todoTypeName
      todoTypeTitle
      todoTypeDescription
      todoTypeColor
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTodoTypeTemplate = /* GraphQL */ `
  subscription OnDeleteTodoTypeTemplate(
    $filter: ModelSubscriptionTodoTypeTemplateFilterInput
  ) {
    onDeleteTodoTypeTemplate(filter: $filter) {
      id
      todoTypeName
      todoTypeTitle
      todoTypeDescription
      todoTypeColor
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateTemplate = /* GraphQL */ `
  subscription OnCreateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
    onCreateTemplate(filter: $filter) {
      id
      type
      typeId
      subType
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateTemplate = /* GraphQL */ `
  subscription OnUpdateTemplate($filter: ModelSubscriptionTemplateFilterInput) {
    onUpdateTemplate(filter: $filter) {
      id
      type
      typeId
      subType
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteTemplate = /* GraphQL */ `
  subscription OnDeleteTemplate($filter: ModelSubscriptionTemplateFilterInput) {
    onDeleteTemplate(filter: $filter) {
      id
      type
      typeId
      subType
      name
      value
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateVesselState = /* GraphQL */ `
  subscription OnCreateVesselState(
    $filter: ModelSubscriptionVesselStateFilterInput
  ) {
    onCreateVesselState(filter: $filter) {
      id
      name
      mmsi
      imo
      callSign
      navStatus
      shipType
      lat
      lon
      height
      depth
      speed
      cmg
      heading
      rot
      positionQuality
      positioningDevice
      eta
      destination
      dimForward
      dimAft
      dimPort
      dimStbd
      recordTimestamp
      positionTimestamp
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateVesselState = /* GraphQL */ `
  subscription OnUpdateVesselState(
    $filter: ModelSubscriptionVesselStateFilterInput
  ) {
    onUpdateVesselState(filter: $filter) {
      id
      name
      mmsi
      imo
      callSign
      navStatus
      shipType
      lat
      lon
      height
      depth
      speed
      cmg
      heading
      rot
      positionQuality
      positioningDevice
      eta
      destination
      dimForward
      dimAft
      dimPort
      dimStbd
      recordTimestamp
      positionTimestamp
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteVesselState = /* GraphQL */ `
  subscription OnDeleteVesselState(
    $filter: ModelSubscriptionVesselStateFilterInput
  ) {
    onDeleteVesselState(filter: $filter) {
      id
      name
      mmsi
      imo
      callSign
      navStatus
      shipType
      lat
      lon
      height
      depth
      speed
      cmg
      heading
      rot
      positionQuality
      positioningDevice
      eta
      destination
      dimForward
      dimAft
      dimPort
      dimStbd
      recordTimestamp
      positionTimestamp
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateAutomationRule = /* GraphQL */ `
  subscription OnCreateAutomationRule(
    $filter: ModelSubscriptionAutomationRuleFilterInput
  ) {
    onCreateAutomationRule(filter: $filter) {
      id
      enabled
      vessels
      allVessels
      plan {
        steps {
          event
          marlinZoneIds
          actions {
            type
            params
            __typename
          }
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateAutomationRule = /* GraphQL */ `
  subscription OnUpdateAutomationRule(
    $filter: ModelSubscriptionAutomationRuleFilterInput
  ) {
    onUpdateAutomationRule(filter: $filter) {
      id
      enabled
      vessels
      allVessels
      plan {
        steps {
          event
          marlinZoneIds
          actions {
            type
            params
            __typename
          }
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteAutomationRule = /* GraphQL */ `
  subscription OnDeleteAutomationRule(
    $filter: ModelSubscriptionAutomationRuleFilterInput
  ) {
    onDeleteAutomationRule(filter: $filter) {
      id
      enabled
      vessels
      allVessels
      plan {
        steps {
          event
          marlinZoneIds
          actions {
            type
            params
            __typename
          }
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateS3File = /* GraphQL */ `
  subscription OnCreateS3File($filter: ModelSubscriptionS3FileFilterInput) {
    onCreateS3File(filter: $filter) {
      id
      name
      s3Path
      mimeType
      sizeBytes
      portCallId
      actionId
      type
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateS3File = /* GraphQL */ `
  subscription OnUpdateS3File($filter: ModelSubscriptionS3FileFilterInput) {
    onUpdateS3File(filter: $filter) {
      id
      name
      s3Path
      mimeType
      sizeBytes
      portCallId
      actionId
      type
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteS3File = /* GraphQL */ `
  subscription OnDeleteS3File($filter: ModelSubscriptionS3FileFilterInput) {
    onDeleteS3File(filter: $filter) {
      id
      name
      s3Path
      mimeType
      sizeBytes
      portCallId
      actionId
      type
      auditMeta {
        comment
        userId
        source
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateNotificationRule = /* GraphQL */ `
  subscription OnCreateNotificationRule(
    $filter: ModelSubscriptionNotificationRuleFilterInput
  ) {
    onCreateNotificationRule(filter: $filter) {
      id
      enabled
      name
      description
      kind
      recipients
      locations
      categories
      tags
      tagsMatchingType
      actionsWithoutLocation
      triggers
      actionTypeId
      type
      offset
      offsetUnit
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateNotificationRule = /* GraphQL */ `
  subscription OnUpdateNotificationRule(
    $filter: ModelSubscriptionNotificationRuleFilterInput
  ) {
    onUpdateNotificationRule(filter: $filter) {
      id
      enabled
      name
      description
      kind
      recipients
      locations
      categories
      tags
      tagsMatchingType
      actionsWithoutLocation
      triggers
      actionTypeId
      type
      offset
      offsetUnit
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteNotificationRule = /* GraphQL */ `
  subscription OnDeleteNotificationRule(
    $filter: ModelSubscriptionNotificationRuleFilterInput
  ) {
    onDeleteNotificationRule(filter: $filter) {
      id
      enabled
      name
      description
      kind
      recipients
      locations
      categories
      tags
      tagsMatchingType
      actionsWithoutLocation
      triggers
      actionTypeId
      type
      offset
      offsetUnit
      deleted
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onCreateCertificateType = /* GraphQL */ `
  subscription OnCreateCertificateType(
    $filter: ModelSubscriptionCertificateTypeFilterInput
  ) {
    onCreateCertificateType(filter: $filter) {
      id
      name
      description
      deleted
      certificateTypeCategoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onUpdateCertificateType = /* GraphQL */ `
  subscription OnUpdateCertificateType(
    $filter: ModelSubscriptionCertificateTypeFilterInput
  ) {
    onUpdateCertificateType(filter: $filter) {
      id
      name
      description
      deleted
      certificateTypeCategoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const onDeleteCertificateType = /* GraphQL */ `
  subscription OnDeleteCertificateType(
    $filter: ModelSubscriptionCertificateTypeFilterInput
  ) {
    onDeleteCertificateType(filter: $filter) {
      id
      name
      description
      deleted
      certificateTypeCategoryId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
